module.exports = __webpack_public_path__ + "img/LBA-Task.157a61f8.svg";